export default {
  "setting.autoUpdate": "Auto Update",
  "setting.localStorage": "Local Storage",
  "setting.notifications": "Notifications",
};
